import React, { useEffect, useState, useRef } from "react";
import HelpBackIcon from './../../../../images/helpbackicon.png'
import {Link, Route, useNavigate} from 'react-router-dom'
import N3rveLogo from './../../../../images/N3rveLogo.png'
import InstagramLogo from './../../../../images/instagramlogo.png'
import TwitterLogo from './../../../../images/twitterlogo.png'
import DiscordLogo from './../../../../images/discordlogo.png'
import AccountSetup from "./SupportPages/AccountSetup";
import DashboardOverview from "./SupportPages/DashboardOverview";
import Analytics from "./SupportPages/Analytics";
import Billing from "./SupportPages/Billing";
import Discussions from "./SupportPages/Discussions";
import FirstUpload from "./SupportPages/FirstUpload";
import Territory from "./SupportPages/Territory";
import Royalties from "./SupportPages/Royalties";
import Performance from "./SupportPages/Performance";
import ReportDownloads from "./SupportPages/ReportDownloads";
import PreSave from "./SupportPages/PreSave";
import SocialMedia from "./SupportPages/SocialMedia";
import YoutubeMonetize from "./SupportPages/YoutubeMonetize";
import GetVerifiedArtist from "./SupportPages/GetVerifiedArtist";
import ReleaseMusic from "./SupportPages/ReleaseMusic";
import SubmitATicket from "./SupportPages/SubmitATicket";
import Security from "./SupportPages/Security";
import ProfileUpdates from "./SupportPages/ProfileUpdates";


function SupportDetails({infopageHeader,setInfoPageHeader}){
 const [feedback,setFeedback] = useState(false)
 const navigate= useNavigate();

  
 return (
    <div style={{minHeight:'100vh',height:'auto'}}>
      {
         infopageHeader==="Account Setup" &&
         <AccountSetup/>
      }
      {
         infopageHeader==="Dashboard Overview" &&
         <DashboardOverview/>
      }
      {
         infopageHeader==="First Upload" &&
         <FirstUpload setInfoPageHeader={setInfoPageHeader}/>
      }


      {
         infopageHeader==="Territory & Rights" &&
         <Territory/>
      }
      {
         infopageHeader==="Royalties" &&
         <Royalties/>
      }

      {
         infopageHeader==="Understanding Analytics" &&
         <Analytics/>
      }

      {
         infopageHeader==="Performance Tips" &&
         <Performance/>
      }

      {
         infopageHeader==="Reports Download" &&
         <ReportDownloads/>
      }

      {
         infopageHeader==="Pre-save Links" &&
         <PreSave/>
      }

      {
         infopageHeader==="Social Media Integration" &&
         <SocialMedia/>
      }

      {
          infopageHeader==="YouTube Monetization" &&
          <YoutubeMonetize/>
      }

      {  
          infopageHeader==="Get Verified" &&
          <GetVerifiedArtist/>
      }

      {  
          infopageHeader==="Release Music" &&
          <ReleaseMusic/>
      }
      
      {
         infopageHeader==="Submit A ticket"&&
         <SubmitATicket/> 
      }

      {
         infopageHeader==="Billing" &&
         <Billing/>
      }

      {
         infopageHeader==="Security" &&
         <Security/>
      }

      {
         infopageHeader==="Profile Updates" &&
         <ProfileUpdates/>
      }
      
      
    </div>
 )
}

export default SupportDetails;